import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import AOS from "aos";
import "aos/dist/aos.css";
import "./News.css";

const API =
  process.env.REACT_APP_API_URL || "http://localhost:5002";

const News = () => {
  const [posts, setPosts] = useState([]);
  const [mainPost, setMainPost] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    AOS.init({
      duration: 1200,
      once: false,
      mirror: true,
    });
  }, []);

  useEffect(() => {
    const fetchAllPosts = async () => {
      try {
        const res = await axios.get(`${API}/api/posts`);
        const allPosts = Array.isArray(res.data) ? res.data : [];

        setPosts(allPosts);
        setMainPost(allPosts[0] || null);

        setTimeout(() => {
          AOS.refresh();
        }, 100);
      } catch (err) {
        console.error("Erreur chargement articles :", err);
      } finally {
        setLoading(false);
      }
    };

    fetchAllPosts();
  }, []);

  const formatDate = (date) => {
    if (!date) return "";
    try {
      return new Date(date).toLocaleDateString("fr-FR", {
        day: "2-digit",
        month: "long",
        year: "numeric",
      });
    } catch {
      return "";
    }
  };

  const getImageSrc = (post) => {
    if (!post?.imageUrl) return "";
    if (post.imageUrl.startsWith("http")) return post.imageUrl;
    return `${API}${post.imageUrl}`;
  };

  if (loading) {
    return (
      <div className="news-page">
        <div className="news-shell">
          <div className="news-loading" data-aos="fade-up">
            Chargement des actualités...
          </div>
        </div>
      </div>
    );
  }

  if (!mainPost) {
    return (
      <div className="news-page">
        <div className="news-shell">
          <div className="news-empty" data-aos="fade-up">
            <h1>News</h1>
            <p>Aucun article disponible pour le moment.</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="news-page">
      <div className="news-shell">
        <div className="news-hero" data-aos="fade-up">
          <h1>News</h1>
          <p>
            Retrouve les dernières actualités, annonces et informations utiles
            pour les utilisateurs.
          </p>
        </div>

        <div className="news-layout">
          <section className="news-main" data-aos="fade-right">
            <article className="news-main-card">
              <div className="news-main-content">
                <span className="news-badge">À la une</span>

                <h2>{mainPost.title}</h2>

                <div className="news-meta">
                  {mainPost.createdAt && (
                    <span>{formatDate(mainPost.createdAt)}</span>
                  )}
                  {mainPost.author && <span>• {mainPost.author}</span>}
                </div>

                {mainPost.imageUrl && (
                  <div
                    className="news-main-image-wrap"
                    data-aos="zoom-in"
                    data-aos-delay="100"
                  >
                    <img
                      src={getImageSrc(mainPost)}
                      alt={mainPost.title}
                      className="news-main-image"
                    />
                  </div>
                )}

                <p className="news-main-excerpt">
                  {mainPost.excerpt ||
                    (mainPost.content
                      ? `${mainPost.content.slice(0, 260)}...`
                      : "Découvrez cet article.")}
                </p>

                <Link to={`/post/${mainPost._id}`} className="news-read-more">
                  Lire l’article complet →
                </Link>
              </div>
            </article>
          </section>

          <aside className="news-sidebar" data-aos="fade-left">
            <div className="news-sidebar-card">
              <h3>Articles précédents</h3>

              <div className="news-sidebar-list">
                {posts.slice(1, 6).map((post, index) => (
                  <Link
                    to={`/post/${post._id}`}
                    key={post._id}
                    className="news-sidebar-post"
                    data-aos="fade-up"
                    data-aos-delay={index * 100}
                  >
                    {post.imageUrl ? (
                      <img
                        src={getImageSrc(post)}
                        alt={post.title}
                        className="news-sidebar-image"
                      />
                    ) : (
                      <div className="news-sidebar-placeholder">NEWS</div>
                    )}

                    <div className="news-sidebar-text">
                      <p className="news-sidebar-title">{post.title}</p>
                      {post.createdAt && (
                        <span className="news-sidebar-date">
                          {formatDate(post.createdAt)}
                        </span>
                      )}
                    </div>
                  </Link>
                ))}
              </div>
            </div>
          </aside>
        </div>
      </div>
    </div>
  );
};

export default News;